import Constants from './Constants';
import CustomerGenerator from './CustomerGenerator';

export default class IceContext {
  constructor(seed, weather, temperature, weekday) {
    this._CustomerGenerator = new CustomerGenerator(seed || Math.random());
    this._weather = weather;
    this._weekday = weekday;
    this._temperature = temperature;
    this._place = -1;
    this._ice = -1;
    this._price = Constants.DEFAULT_PRICE;
    this._stockNum = 10;
    this._started = false;
    if (this._weekday === undefined) {
      this._weekday = Constants.getRandomWeekday();
    }
    if (this._weather === undefined) {
      this._weather = Constants.getRandomWeather();
    }
    if (this._temperature === undefined) {
      this._temperature = Constants.getRandomTemperature();
    }
    this.resetResults();
  }

  resetResults() {
    const len = Constants.END_HOUR - Constants.START_HOUR;
    let i = 0;

    this._salesData = new Array(len);
    this._priceSalesData = [];
    this._customersData = [];
    this._purchasersData = [];
    this._priceTransitionData = new Array(len * 6 + 1); // 10分ごとに記録する。また最後の時間にlabelを置くため +1する

    for (i = 0; i < Constants.CUSTOMER_LENGTH; i++) {
      this._customersData.push(new Array(len));
      this._purchasersData.push(new Array(len));
    }
    for (i = 0; i < len; i++) {
      this._salesData[i] = 0;
      for (let j = 0; j < Constants.CUSTOMER_LENGTH; j++) {
        this._customersData[j][i] = 0;
        this._purchasersData[j][i] = 0;
      }
    }
    for (i = 0; i < this._priceTransitionData.length; i++) {
      this._priceTransitionData[i] = 0;
    }
  }

  /**
   * data is
   * {
   *  hour: x
   *  price: x
   * }
   */
  addSalesData(data) {
    this._salesData[data.hour - Constants.START_HOUR] += data.price;

    if (data.price === 0) {
      return;
    }

    var total = this._priceSalesData.find(function(element) {
      return element.price === data.price;
    });
    if (total) {
      total.num += +1;
      total.total += data.price;
    } else {
      this._priceSalesData.push({
        price: data.price,
        num: 1,
        total: data.price,
      });
    }
  }

  /**
   * data is
   * {
   *  hour: x
   *  data: [customer.type] => number
   * }
   */
  addCustomersData(data) {
    for (let i = 0; i < Constants.CUSTOMER_LENGTH; i++) {
      this._customersData[i][data.hour - Constants.START_HOUR] += data.data[i];
    }
  }

  /**
   * data is
   * {
   *  hour: x
   *  data: [customer.type] => number
   * }
   */
  addPurchasersData(data) {
    this._started = true;
    for (let i = 0; i < Constants.CUSTOMER_LENGTH; i++) {
      this._purchasersData[i][data.hour - Constants.START_HOUR] += data.data[i];
    }
  }

  /**
   * data is
   * {
   *  hour: x,
   *  min_step: x, // min % 10
   *  price: x,
   * }
   * @param data
   */
  addPriceTransitionData(data) {
    this._priceTransitionData[(data.hour - Constants.START_HOUR) * 6 + data.min_step] = data.price;
    // 終わり時間の値はcallされないため、最後に呼ばればpriceが入るようにする。
    this._priceTransitionData[this._priceTransitionData.length - 1] = data.price;
  }

  get totalSales() {
    let total = 0;
    this._salesData.forEach(function(price) {
      total += price;
    });
    return total;
  }

  get customers() {
    if (!this._customers) {
      this._customers = this._CustomerGenerator.calcCustomers(this);
    }
    return this._customers;
  }

  get weather() {
    return this._weather;
  }

  get temperature() {
    return this._temperature;
  }

  get place() {
    return this._place;
  }

  get ice() {
    return this._ice;
  }

  get price() {
    return this._price;
  }

  get stockNum() {
    return this._stockNum;
  }

  get salesData() {
    return this._salesData;
  }

  get started() {
    return this._started;
  }

  get weekday() {
    return this._weekday;
  }

  get priceSalesData() {
    const MAX_COIN_NUM = 50.0;
    const MIN_PRICE = 0;
    let results = [];

    // もらったお金でsort.
    let priceSalesData = this._priceSalesData.sort((a, b) => {
      return b.total - a.total;
    });

    // 5位以下をまとめる。あとで、priceでソートするときのために、MAX_PRICEを設定しておく。
    priceSalesData.forEach(function(data, index) {
      if (index < 4) {
        results.push(data);
      } else if (index === 4) {
        results.push({ total: data.total, price: MIN_PRICE, num: data.num });
      } else {
        results[4].total += data.total;
        results[4].num += data.num;
      }
    });

    // コインの数を相対的に決めるために、もらったお金の最大値を計算
    let max = 1;
    results.forEach(function(data) {
      if (max < data.total) {
        max = data.total;
      }
    });

    // 表示するコインの数を計算
    results.forEach(data => {
      data.coin = Math.ceil((MAX_COIN_NUM * data.total) / max);
    });

    // もらったお金でソート。
    results = results.sort((a, b) => {
      return b.price - a.price;
    });

    // "ほか"と表示するために、priceを変更
    if (results.length > 4) {
      results[4].price = 'ほか';
    }
    return results;
  }

  get totalSalesNum() {
    let num = 0;
    this._priceSalesData.forEach(data => {
      num += data.num;
    });
    return num;
  }

  get customersData() {
    return this._customersData;
  }

  get purchasersData() {
    return this._purchasersData;
  }

  get priceTransitionData() {
    return this._priceTransitionData;
  }

  set weather(weather) {
    this._weather = weather;
  }

  set temperature(temperature) {
    this._temperature = temperature;
  }

  set place(place) {
    this._place = place;
  }

  set ice(ice) {
    this._ice = ice;
  }

  set price(price) {
    this._price = price;
  }

  set stockNum(stockNum) {
    this._stockNum = stockNum;
  }

  set weekday(weekday) {
    this._weekday = weekday;
  }
}
